export const homeworkStatus = ['-', '-', 'Pending', 'Incomplete', 'Completed']

export const ACCEPTED_HOMEWORK = 4

export const REJECTED_HOMEWORK = 3

export const FULL_WATCHED = 100
